/* Vendora PDP — Wildberries-style behaviour layer */
(function () {
  'use strict';

  var desktopHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  function formatSize(value) {
    var parts = String(value || '').split('-');
    if (parts.length === 2) {
      return (
        parts[0].toUpperCase() +
        '\u00A0\u00B7\u00A0' +
        parts[1].replace(/X/g, '\u00D7').replace(/cm$/i, ' cm')
      );
    }
    return String(value || '');
  }

  /* --------------------------------------------------------------------
     1. Hover a thumbnail to switch the main image (desktop only)
     -------------------------------------------------------------------- */
  function initThumbHover() {
    document.querySelectorAll('[id^="GalleryThumbnails"] li[data-target]').forEach(function (li) {
      var locked = false;
      li.addEventListener('mouseenter', function () {
        if (!desktopHover.matches || locked) return;
        var gallery = li.closest('media-gallery');
        if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
        locked = true;
        try {
          gallery.setActiveMedia(li.dataset.target, false);
        } catch (err) {
          /* ignore */
        }
        window.setTimeout(function () {
          locked = false;
        }, 200);
      });
    });
  }

  /* --------------------------------------------------------------------
     2. Size guide modal
     -------------------------------------------------------------------- */
  function initSizeGuide() {
    var modal = document.getElementById('wb-size-guide');
    if (!modal) return;

    function open() {
      modal.classList.add('is-open');
      modal.removeAttribute('aria-hidden');
      document.body.classList.add('wb-modal-open');
      var closeBtn = modal.querySelector('.wb-size-guide__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('.wb-specs-modal.is-open')) {
        document.body.classList.remove('wb-modal-open');
      }
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-wb-size-guide-open]')) {
        event.preventDefault();
        open();
        return;
      }
      if (event.target.closest('[data-wb-size-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  /* --------------------------------------------------------------------
     3. Keep the specification rows in sync with the selected variant
     -------------------------------------------------------------------- */
  function selectedOptionValue(inputGroup) {
    var checked = inputGroup.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (checked) return checked.value;
    var select = inputGroup.querySelector('select');
    if (select) return select.value;
    var first = inputGroup.querySelector('input[type="radio"], input[type="checkbox"], input[type="text"]');
    return first ? first.value : null;
  }

  function syncSpecs() {
    var sizeValue = null;
    var colorValue = null;

    document.querySelectorAll('variant-selects .product-form__input').forEach(function (group) {
      var label = group.querySelector('.form__label');
      if (!label) return;
      var name = (label.textContent || '').trim().toLowerCase();
      var value = selectedOptionValue(group);
      if (!value) return;
      if (name.indexOf('size') !== -1) sizeValue = value;
      else if (name.indexOf('color') !== -1 || name.indexOf('colour') !== -1) colorValue = value;
    });

    var sizeRows = document.querySelectorAll('[data-wb-spec="size"]');
    var colorRows = document.querySelectorAll('[data-wb-spec="color"]');
    sizeRows.forEach(function (row) {
      if (sizeValue) row.textContent = formatSize(sizeValue);
    });
    colorRows.forEach(function (row) {
      if (colorValue) row.textContent = colorValue;
    });
  }

  /* --------------------------------------------------------------------
     4. "Specifications & description" modal
     -------------------------------------------------------------------- */
  /* Drawer footer mirrors the currently selected variant, so Buy always
     adds what the shopper picked on the page. */
  function syncModalBuy() {
    var modal = document.getElementById('wb-specs-modal');
    if (!modal) return;
    var mainVariant = document.querySelector('product-form form [name="id"]');
    var modalVariant = modal.querySelector('[data-wb-specs-variant]');
    if (mainVariant && modalVariant && mainVariant.value) {
      modalVariant.value = mainVariant.value;
    }
    var mainPrice = document.querySelector(
      '.wb-buy-card .price-item--sale, .wb-buy-card .price-item--regular, .product__info-container .price-item--sale, .product__info-container .price-item--regular'
    );
    var modalPrice = modal.querySelector('[data-wb-specs-price]');
    if (mainPrice && modalPrice && mainPrice.textContent.trim() !== '') {
      modalPrice.textContent = mainPrice.textContent;
    }
  }

  function initSpecsLink() {
    var modal = document.getElementById('wb-specs-modal');
    if (!modal) return;

    // Park the modal directly under <body> on first open. Any transformed
    // / animated ancestor would otherwise become its containing block and
    // shift the drawer (no :has() support needed for this path).
    var modalHome = null;
    function parkInBody() {
      if (!modalHome && modal.parentElement !== document.body) {
        modalHome = document.createComment('wb-specs-modal home');
        modal.parentElement.insertBefore(modalHome, modal);
        document.body.appendChild(modal);
      }
    }

    function open() {
      parkInBody();
      syncModalBuy();
      modal.classList.add('is-open');
      modal.removeAttribute('aria-hidden');
      document.body.classList.add('wb-modal-open');
      var closeBtn = modal.querySelector('.wb-specs-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('.wb-size-guide.is-open')) {
        document.body.classList.remove('wb-modal-open');
      }
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-wb-specs-open]')) {
        event.preventDefault();
        open();
        return;
      }
      if (event.target.closest('[data-wb-specs-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  /* --------------------------------------------------------------------
     5. Gallery overlay arrows — switch the active media directly so they
        also work on desktop, where inactive slides are display:none and
        plain slider scrolling is a no-op.
     -------------------------------------------------------------------- */
  function initGalleryArrows() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.gallery-arrow');
      if (!btn) return;
      var viewer = btn.closest('slider-component');
      var gallery = btn.closest('media-gallery');
      if (!viewer || !gallery || typeof gallery.setActiveMedia !== 'function') return;
      var items = Array.prototype.slice.call(viewer.querySelectorAll('.product__media-item'));
      if (items.length < 2) return;
      var current = gallery.querySelector('.product__media-item.is-active') || items[0];
      var index = items.indexOf(current);
      var dir = btn.getAttribute('name') === 'previous' ? -1 : 1;
      var next = items[(index + dir + items.length) % items.length];
      if (next && next.dataset.mediaId) {
        gallery.setActiveMedia(next.dataset.mediaId, false);
      }
    });
  }

  function init() {
    initThumbHover();
    initSizeGuide();
    initSpecsLink();
    initGalleryArrows();
    syncSpecs();

    document.addEventListener('change', function (event) {
      if (event.target.closest && event.target.closest('variant-selects')) syncSpecs();
    });

    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.eventPublisher) {
      var publisher = window.Shopify.theme.eventPublisher;
      if (typeof publisher.subscribe === 'function') {
        publisher.subscribe('variantChange', syncSpecs);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
